import React, { useState, useMemo } from "react";
import { sortIcon } from "components/Icons";
import JobServicesRow from "./JobServicesRow";

export default function JobServicesTable({ jobServiceList }) {
  const [sortColumn, setSortColumn] = useState(null);
  const [sortDesc, setSortDesc] = useState(false);

  const displayedJobServiceList = useMemo(() => {
    if (!sortColumn) return jobServiceList;

    return [...jobServiceList].sort((a, b) => {
      const timeA = sortColumn === "fieldWork"
        ? new Date(a.attributes.bookingDates?.[0] || 0).getTime()
        : new Date(a.attributes.clientDueDate || 0).getTime();
      const timeB = sortColumn === "fieldWork"
        ? new Date(b.attributes.bookingDates?.[0] || 0).getTime()
        : new Date(b.attributes.clientDueDate || 0).getTime();

      return sortDesc ? timeB - timeA : timeA - timeB;
    });
  }, [jobServiceList, sortColumn, sortDesc]);

  return (
    <div className="table-responsive table-responsive-no-mobile">
      <table className="table table-listing table-hover">
        <thead>
          <tr>
            <th>Job No.</th>
            <th>Job Address</th>
            <th>Client Name</th>
            <th className="absorbing-column">Client Number</th>
            <th>Job Service</th>
            <th className="text-center">Status</th>
            <th className="text-center absorbing-column">
              <span className="mr-1">Date of Field Work</span>
              <span type="button" onClick={() => {
                if (sortColumn === "fieldWork") setSortDesc(!sortDesc);
                else { setSortColumn("fieldWork"); setSortDesc(false); }
              }}>
                <img src={sortIcon} />
              </span>
            </th>
            <th className="text-center absorbing-column">
              <span className="mr-1">Due Date</span>
              <span type="button" onClick={() => {
                if (sortColumn === "dueDate") setSortDesc(!sortDesc);
                else { setSortColumn("dueDate"); setSortDesc(false); }
              }}>
                <img src={sortIcon} />
              </span>
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {!!displayedJobServiceList?.length && displayedJobServiceList.map(job => (
            <JobServicesRow key={job.attributes.id} job={job} />
          ))}
        </tbody>
      </table>
    </div>
  );
}
